import React from 'react';
import { Input } from 'antd';

interface NumberProp {
  value?: number | string;
  onChange?: (value: number) => void;
  placeholder?: string;
  readOnly?: boolean;
  status?: '' | 'error' | 'warning';
}

const NumberInput: React.FC<NumberProp> = ({ value, onChange, placeholder, readOnly, status }) => {
  // Format number with commas
  const formatNumber = (num: number | string) => {
    if (num === '' || num === null || num === undefined) return '';
    return new Intl.NumberFormat().format(Number(num));
  };

  // Remove formatting before saving the value
  const parseNumber = (formattedValue: string) => {
    return formattedValue.replace(/[^\d.-]/g, "");
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const rawValue = e.target.value;
    const cleanValue = parseNumber(rawValue);
    if (onChange) onChange(Number(cleanValue));
  };

  return (
    <Input
      size="small"
      placeholder={placeholder}
      className="text-right text-primary"
      value={formatNumber(value ?? 0)}
      onChange={handleChange}
      readOnly={readOnly}
      status={status}
    />
  );
};

export default NumberInput;
